
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/dirt-at-wheels",
      function () {
        return require("private-next-pages/brands/dirt-at-wheels.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/dirt-at-wheels"])
      });
    }
  